import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'Lucía', 'Roberto', 'Gabriela', 'Diego', 'Patricia', 'Fernando', 'Silvia'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotification({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification (random between 10-20 seconds)
      const nextDelay = Math.random() * 10000 + 10000;
      setTimeout(showNotification, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm w-full animate-in slide-in-from-left duration-500" data-id="element-16">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex items-center gap-4" data-id="element-17">
        <div className="flex-shrink-0" data-id="element-18">
          <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-19">
            <CheckCircle className="h-6 w-6 text-green-600" data-id="element-20" />
          </div>
        </div>
        <div data-id="element-21">
          <p className="text-sm font-medium text-gray-900" data-id="element-22">
            <span className="font-bold" data-id="element-23">{notification.name}</span> de{' '}
            <span className="font-bold" data-id="element-24">{notification.city}</span>
          </p>
          <p className="text-sm text-gray-500" data-id="element-25">
            acaba de comprar este libro digital
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-26">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}